import { RequestInterceptor } from "@/types/http/request-interceptor";
import { AxiosRequestConfig } from "axios";
import { I18nStorageService } from "@/services/i18n-storage.service";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * I18n request interceptor.
 * It adds accept-language header with currently set locale id.
 */
export const i18nInterceptor: RequestInterceptor = {
  onFulfilled(
    value: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> | AxiosRequestConfig {
    value.headers["accept-language"] = I18nStorageService.locale;
    return value;
  }
};
